module.exports = __webpack_public_path__ + "static/media/logo.4b02f5e0.jpg";